import React, { useMemo } from "react";
import TabsCoursesMobile from "./TabsCoursesMobile";
import TabsCoursesDesktop from "./TabsCoursesDesktop";

import "./styles.scss";
import { showMobile } from "helpers/adaptation";
import { BiddingEnum } from "enums/enums";
import { ICourseValue } from "types/common";

export interface TabsCoursesProps {
  RenderComponent?: any;
  dataAllCourses: any;
  onSelect: (k: any) => void;
  searchRes?: any;
  onPressItem?: (
    val: ICourseValue,
    type: BiddingEnum.BIDDING | BiddingEnum.INTERACTIVE_BIDDING,
    isBidPlay: boolean
  ) => void;
  onPressTricksPlay?: (val: any) => void;
  onPressHandPlay?: (val: any) => void;
  onPressDefLeadPlay?: (val: any) => void;
  onPressDeffensePlay?: (val: any) => void;
  onPressMiniBridge?: (val: any) => void;
  search?: string;
  type: "bidding" | "handPlay_tricks" | "deffense_deflead";
  listTitle: any;
  keyTab: string | undefined;
  listKeys?: string[] | undefined;
  onExpiredClose?: () => void;
  isExpired?: boolean;
}

const TabsCourses = (props: TabsCoursesProps) => {
  const listKeys = useMemo(() => {
    if (props.dataAllCourses) {
      const list = Object.keys(props.dataAllCourses);
      if (list.length) {
        return list;
      }
      return undefined;
    }
    return undefined;
  }, [props.dataAllCourses]);
  return (
    <>
      {!showMobile && <TabsCoursesDesktop {...props} listKeys={listKeys} />}
      {showMobile && <TabsCoursesMobile {...props} listKeys={listKeys} />}
    </>
  );
};

export default TabsCourses;
